import styled from '@emotion/styled';
import { fromTheme } from '@kyruus/ui-theme';
import Button from '@kyruus/button';

/**
 * Styled components for the MapPinSlideSheet
 */

export const DrawerContent = styled.div`
  width: ${(props) => props.width};
  body:not(.in-iframe) {
    height: 100vh;
  }
  body(.in-iframe) {
    height: 100%;
  }
  overflow-y: auto;
`;

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: ${fromTheme('spacing_large')} ${fromTheme('spacing_large')}
    ${fromTheme('spacing_large')};
  position: sticky;
  top: 0;
  background-color: ${fromTheme('color_background')};
  z-index: 1;
`;

export const CloseButtonContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const ContentContainer = styled.div`
  padding-left: ${fromTheme('spacing_large')};
  padding-right: ${fromTheme('spacing_large')};
  padding-bottom: ${fromTheme('spacing_large')};
`;

export const CloseButton = styled(Button)`
  padding: 0 !important;
  min-width: auto !important;
`;
